import { useCallback, useState } from "react";
import { getSavedSection } from "utils/api";
import { useAsyncLoader } from "../../useAsyncLoader";

export default function useSavedLocation() {
  const [updateSavedLocation, setUpdateSavedLocation] = useState(new Date());
  const { data: savedLocation, isLoading: savedLocationLoading, error } = useAsyncLoader(
    getSavedSection,
    updateSavedLocation
  );

  const reloadSavedLocation = useCallback(() => setUpdateSavedLocation(new Date()), []);

  return [savedLocation, savedLocationLoading, reloadSavedLocation];
}
